import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {BaseInfoService} from 'app/services/base-info.service';
@Component({
  selector: 'app-paya-reason',
  templateUrl: './paya-reason.component.html',
  styleUrls: ['./paya-reason.component.scss']
})
export class PayaReasonComponent implements OnInit, OnChanges {
  selectedReason = '';
  payaReasonList = [];
  satnaReasonList = [];
  allReasons = [];
  reasonList = [];
  @Input() reasonId = '#reasonSelect';
  @Input() hasError = false;
  @Input() getReason;
  @Input() amount = 0;
  @Input() reasonCode;
  // @Input() onlyPaya = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  constructor(private service: BaseInfoService) { }
  ngOnInit(): void {
    this.allReasons = JSON.parse(sessionStorage.getItem('satna-payaReason'));
    if (this.allReasons === null) {
      this.getPayaSatnaReason();
    } else {
      this.doStuff();
    }
  }
  ngOnChanges() {
    if (Number(this.amount) >= 150000000) {
      this.reasonList = this.satnaReasonList;
      this.selectFirst();
    } else {
      this.reasonList = this.payaReasonList;
      this.selectFirst();
    }

  }
  sendParentNotification(event) {
    document.getElementById(this.reasonId).classList.add('focused');
    this.notifyParent.emit(this.selectedReason);
  }
  selectFirst() {
    if (this.reasonList.length > 0 && this.selectedReason === '') {
      this.selectedReason = this.reasonList[0];
      this.notifyParent.emit(this.selectedReason);
      document.getElementById(this.reasonId).classList.add('focused');
    }
  }
  getPayaSatnaReason() {
    this.service.getPayaSatnaReason().subscribe(
      res => {
        if (res.code === 0) {
          this.allReasons = res.content.reasonList;
          sessionStorage.setItem('satna-payaReason', JSON.stringify(res.content.reasonList));
          this.doStuff();
        }
      }
    );
  }
  doStuff() {
    // tslint:disable-next-line:only-arrow-functions
    const temp = this.allReasons.reduce(function(obj, value) {
      const key = value.type;
      if (obj[key] == null) {
        obj[key] = [];
      }
      obj[key].push(value);
      return obj;
    }, {});
    this.payaReasonList = temp.paya;
    this.satnaReasonList = temp.satna;
    // this.reasonList = this.payaReasonList;
    // if (this.reasonList !== null && this.reasonList.length > 0) {
    //   if (this.getReason) {
    //     this.selectedReason = this.reasonList.find(el => el.depositNumber === this.getReason.depositNumber);
    //     this.notifyParent.emit(this.selectedReason);
    //   }
    // }
    if (this.amount) {
      if (Number(this.amount) >= 150000000) {
        this.reasonList = this.satnaReasonList;
      } else {
        this.reasonList = this.payaReasonList;
      }
    } else {
      this.reasonList = this.payaReasonList;
    }
    if (this.reasonList !== null && this.reasonList.length > 0) {
      if (this.reasonCode) {
        this.selectedReason = this.reasonList.find(el => el.reasonCode === this.reasonCode);
        this.notifyParent.emit(this.selectedReason);
        // document.getElementById(this.reasonId).classList.add('focused');
      }
    }
  }
}
